import { useEffect, useState } from 'react';
import { Cloud, Sun, CloudRain, CloudSnow, Wind, CloudLightning } from 'lucide-react';

// Saint-Etienne (Pilat) coords
const LAT = 45.4397;
const LON = 4.3872;

// Open-Meteo current weather codes -> {icon, label}
const WEATHER_MAP = {
  0:  { icon: Sun,   label: 'soleil' },
  1:  { icon: Sun,   label: 'ciel degage' },
  2:  { icon: Cloud, label: 'partiellement nuageux' },
  3:  { icon: Cloud, label: 'nuageux' },
  45: { icon: Cloud, label: 'brouillard' },
  48: { icon: Cloud, label: 'brouillard givrant' },
  51: { icon: CloudRain, label: 'bruine' },
  53: { icon: CloudRain, label: 'bruine' },
  55: { icon: CloudRain, label: 'bruine' },
  61: { icon: CloudRain, label: 'pluie legere' },
  63: { icon: CloudRain, label: 'pluie' },
  65: { icon: CloudRain, label: 'forte pluie' },
  71: { icon: CloudSnow, label: 'neige' },
  73: { icon: CloudSnow, label: 'neige' },
  75: { icon: CloudSnow, label: 'forte neige' },
  80: { icon: CloudRain, label: 'averses' },
  81: { icon: CloudRain, label: 'averses' },
  82: { icon: CloudRain, label: 'fortes averses' },
  95: { icon: CloudLightning, label: 'orage' },
  96: { icon: CloudLightning, label: 'orage' },
  99: { icon: CloudLightning, label: 'orage' },
};

const TAGLINE_BY_CONDITION = {
  Sun: 'ideal pour une rando dans le Pilat',
  Cloud: 'parfait pour se promener',
  CloudRain: 'cocoon devant la cheminee',
  CloudSnow: 'magique sous la neige',
  CloudLightning: 'spectacle de la nature',
  Wind: 'air pur du Pilat',
};

export default function WeatherWidget() {
  const [data, setData] = useState(null);

  useEffect(() => {
    const url = `https://api.open-meteo.com/v1/forecast?latitude=${LAT}&longitude=${LON}&current=temperature_2m,weather_code,wind_speed_10m&timezone=auto`;
    fetch(url)
      .then(r => r.json())
      .then(json => {
        const c = json?.current;
        if (!c) return;
        const code = c.weather_code;
        const info = WEATHER_MAP[code] || { icon: Cloud, label: 'temps doux' };
        setData({
          temp: Math.round(c.temperature_2m),
          wind: Math.round(c.wind_speed_10m),
          icon: info.icon,
          label: info.label,
          iconKey: info.icon.displayName || info.icon.name,
        });
      })
      .catch(() => {});
  }, []);

  if (!data) return null;
  const Icon = data.icon;
  const tagline = TAGLINE_BY_CONDITION[data.iconKey] || 'air pur du Pilat';

  return (
    <div
      data-testid="weather-widget"
      className="inline-flex items-center gap-2.5 px-4 py-2.5 rounded-full bg-white/12 backdrop-blur-md border border-white/20 text-white/90 text-[11px] font-light tracking-[0.05em]"
    >
      <Icon className="w-3.5 h-3.5 text-[#CBA77A]" strokeWidth={1.7} />
      <span><span className="font-medium tracking-wide">{data.temp}°</span> &middot; {data.label}</span>
      <span className="hidden md:inline text-white/30">·</span>
      <span className="hidden md:inline italic text-white/65">{tagline}</span>
    </div>
  );
}
